import React, { useMemo } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Typography,
  styled,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import "./index.css";
import Image from "next/image";
import { AddToCartService } from "../../../services/cart";
import { Guide } from "./Guide";
import { useCurrencyCode } from "../helper-functions/CurrencySymbol";
import MaxServiceAlert from "./MaxServiceAlert";

interface CardProps {
  id: any;
  cid: any;
  url: any;
  heading: any;
  subHeading: any;
  finalPrice: any;
  discount: any;
  price: any;
  serviceDetails: any;
  handleViewDetails: any;
  handleOpenViewDetailsRsOne: any;
  addOn: any;
  updateCard: any;
  setUpdateCard: any;
  reloadViewDetailsItem: any;
  productDetailsAvailable: any;
  makeYourOwnPackage: boolean;
  handleEditPackage: any;
  recommendedServices: any;
  setOpenBestPaired: any;
  setRecommendedServices: any;
  serviceCharge: any;
  productCost: any;
  min: any;
  specialPrice: any;
  specialMessage: any;
}

export const Card: React.FC<CardProps> = ({
  id,
  cid,
  url,
  heading,
  subHeading,
  finalPrice,
  discount,
  price,
  serviceDetails,
  handleViewDetails,
  handleOpenViewDetailsRsOne,
  addOn,
  updateCard,
  setUpdateCard,
  reloadViewDetailsItem,
  productDetailsAvailable,
  makeYourOwnPackage,
  handleEditPackage,
  recommendedServices,
  setOpenBestPaired,
  setRecommendedServices,
  serviceCharge,
  productCost,
  min,
  specialPrice,
  specialMessage,
}) => {
  const [isClicked, setIsClicked] = React.useState(false);
  const [openMaxService, setOpenMaxService] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const [value, setVaue] = React.useState(1);
  const addToCartService = useMemo(() => new AddToCartService(), []);
  const currencyCode = useCurrencyCode();

  const ScrollContainer = styled(Box)`
    overflow: auto;

    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
    &::-webkit-scrollbar {
      display: none; /* Webkit browsers */
    }
  `;
  React.useEffect(() => {
    var jsonCount = addToCartService.checkIfAvailable(id, cid);
    if (jsonCount.count > 0) {
      setIsClicked(true);
      setVaue(jsonCount.count);
    } else {
      setIsClicked(false);
    }
    setUpdateCard(false);
  }, [updateCard, addToCartService, id, cid, setUpdateCard]);

  const handleClickButton = async () => {
    console.log("id of service add into cart " + id);
    setIsLoading(true);
    if (addOn == true) {
      handleOpenViewDetailsRsOne();
      setIsLoading(false);
    } else {
      var countJson = await addToCartService.addToCart(
        id,
        true,
        cid,
        url,
        serviceDetails,
        subHeading,
        serviceCharge,
        productCost,
        min,
        specialPrice,
        specialMessage
      );
      if (countJson?.count && countJson?.count > 0) {
        setVaue(countJson?.count);
        setIsClicked(true);
        reloadViewDetailsItem();
        setIsLoading(false);
      } else {
        setIsClicked(false);
        reloadViewDetailsItem();
        setIsLoading(false);
      }
    }
  };

  const handleValueDecrease = async () => {
    setIsLoading(true);
    var countJson = await addToCartService.addToCart(
      id,
      false,
      cid,
      url,
      serviceDetails,
      subHeading,
      serviceCharge,
      productCost,
      min,
      specialPrice,
      specialMessage
    );
    if (countJson?.count && countJson?.count > 0) {
      setVaue(countJson?.count);
      setIsClicked(true);
      reloadViewDetailsItem();
      setIsLoading(false);
    } else {
      setIsClicked(false);
      reloadViewDetailsItem();
      setIsLoading(false);
    }
  };

  const handleValueIncrease = async () => {
    setIsLoading(true);
    var countJson = await addToCartService.addToCart(
      id,
      true,
      cid,
      url,
      serviceDetails,
      subHeading,
      serviceCharge,
      productCost,
      min,
      specialPrice,
      specialMessage
    );
    if (countJson?.count && countJson?.count > 0) {
      setVaue(countJson.count);
      setIsClicked(true);
      reloadViewDetailsItem();
      if (countJson?.count === 5) {
        setOpenMaxService(true);
      }
      setIsLoading(false);
    } else {
      setIsClicked(false);
      reloadViewDetailsItem();
      setIsLoading(false);
    }
  };

  const handleBestPaired = () => {
    setOpenBestPaired(true);
    setRecommendedServices(recommendedServices);
  };

  return (
    <>
      <Box
        key={"serviceCard" + id}
        sx={{
          height: "316px",
          borderRadius: "1rem",
          boxShadow: "2px 2px 4px 2px rgba(0, 0, 0, 0.2)",
          margin: "12px",
          minWidth: "265px",
          maxWidth: { xs: "270px", sm: "300px" },
        }}
      >
        <Box
          sx={{
            overflow: "hidden",
            borderRadius: "1rem 1rem 0px 0px",
            height: "80px",
          }}
        >
          <Image
            src={url}
            alt="icon"
            className="card-image-animation"
            style={{
              objectFit: "cover",
              height: "80px",
              width: "100%",
              borderRadius: "1rem 1rem 0px 0px",
            }}
            width={500}
            height={200}
            // priority={true}
            // rel="preload"
            loading="lazy"
          />
        </Box>
        <Box sx={{ padding: "1rem" }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography
              variant="body2"
              sx={{
                fontWeight: "bold",
                fontSize: "12px",
                textWrap: "nowrap",
                overflow: "scroll",
                marginBottom: "5px",
                textOverflow: "ellipsis",
                textTransform: "capitalize",
                maxWidth: productDetailsAvailable == true ? "10rem" : "auto",
                "&:: -webkit-scrollbar": {
                  display: "none",
                },
              }}
            >
              {heading}
            </Typography>
            {productDetailsAvailable == true && <Guide serviceId={id} />}
            {isClicked && recommendedServices?.length > 0 && (
              <Button
                variant="outlined"
                color="success"
                sx={{
                  textTransform: "capitalize",
                  fontSize: "10px",
                  padding: "4px 6px",
                  lineHeight: "12px",
                  textWrap: "nowrap",
                }}
                onClick={handleBestPaired}
              >
                Best paired
              </Button>
            )}
          </Box>
          <Typography
            variant="body2"
            sx={{
              fontSize: "11px",
              textWrap: "nowrap",
              overflow: "auto",
              marginTop: "2px",
              textTransform: "capitalize",
              "&::-webkit-scrollbar": {
                display: "none",
              },
            }}
          >
            {subHeading}
          </Typography>
          <ScrollContainer sx={{ height: "6rem", marginTop: "5px" }}>
            {serviceDetails?.map((item: any, index: any) => (
              <Box sx={{ display: "flex", alignItems: "center" }} key={index}>
                <CheckIcon sx={{ color: "green", paddingRight: "5px" }} />
                <Typography
                  variant="caption"
                  sx={{
                    textWrap: "nowrap",
                  }}
                >
                  {item}
                </Typography>
              </Box>
            ))}
          </ScrollContainer>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              margin: "5px 0px 8px",
              overflow: "auto",
            }}
          >
            <Typography
              variant="body2"
              sx={{
                fontWeight: "bold",
                color: "#000",
                fontSize: currencyCode == "NPR" ? "12px" : "14px",
              }}
            >
              {currencyCode}
              {finalPrice.toLocaleString()}
            </Typography>
            <Typography
              variant="body2"
              sx={{
                fontWeight: "100",
                paddingLeft: "10px",
                color: "gray",
                textDecoration: "line-through",
                fontSize: currencyCode == "NPR" ? "12px" : "14px",
              }}
            >
              {currencyCode}
              {price.toLocaleString()}
            </Typography>
            <Typography
              variant="body2"
              sx={{
                fontWeight: "bold",
                paddingLeft: "10px",
                color: "#15741a",
                fontSize: currencyCode == "NPR" ? "12px" : "14px",
              }}
            >
              <span style={{ fontWeight: "100", color: "#15741a" }}>Save</span>
              &nbsp;
              {currencyCode}
              {discount.toLocaleString()}
            </Typography>
          </Box>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            {makeYourOwnPackage ? (
              <Button
                variant="outlined"
                aria-hidden="false"
                sx={{
                  fontSize: "11px",
                  textTransform: "capitalize",
                  fontWeight: "bold",
                  padding: "6px 20px",
                  borderRadius: "10rem",
                  width: "115px",
                  boxShadow: "none",
                }}
                color="success"
                onClick={handleEditPackage}
              >
                Edit Package
              </Button>
            ) : (
              <Button
                variant="outlined"
                aria-hidden="false"
                sx={{
                  fontSize: "11px",
                  textTransform: "capitalize",
                  fontWeight: "bold",
                  padding: "6px 20px",
                  borderRadius: "10rem",
                  width: "115px",
                  boxShadow: "none",
                }}
                color="success"
                onClick={handleViewDetails}
              >
                View Details
              </Button>
            )}
            {isLoading ? (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "115px",
                  background: "none",
                  borderRadius: "10rem",
                  border: "1px solid #15741a",
                }}
              >
                <CircularProgress size="25px" color="success" />
              </Box>
            ) : isClicked ? (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-evenly",
                  width: "115px",
                  background: "#15741a",
                  borderRadius: "10rem",
                  color: "white",
                }}
              >
                <RemoveIcon
                  onClick={handleValueDecrease}
                  sx={{ cursor: "pointer" }}
                />
                <Typography
                  sx={{
                    fontSize: "14px",
                  }}
                >
                  {value}
                </Typography>
                <AddIcon
                  onClick={handleValueIncrease}
                  sx={{ cursor: "pointer" }}
                />
              </Box>
            ) : (
              <Button
                variant="contained"
                sx={{
                  fontSize: "11px",
                  textTransform: "capitalize",
                  fontWeight: "bold",
                  padding: "6px 20px",
                  borderRadius: "10rem",
                  width: "115px",
                  boxShadow: "none",
                  backgroundColor: "#15741a",
                }}
                color="success"
                onClick={handleClickButton}
              >
                Add to Cart
              </Button>
            )}
          </Box>
        </Box>
      </Box>
      <MaxServiceAlert
        openInfo={openMaxService}
        handleClose={() => setOpenMaxService(false)}
      />
    </>
  );
};

export default Card;
